<template>
  <div class="col-12 col-md-6 col-xl-4 placeholder-glow">
    <div class="card shadow mb-3 p-1" style="min-height: 220px;">
      <div class="row g-0">
        <div class="col-4">
          <img :src="imagem_montada" v-if="!ativa_placeholder" :class="class_placeholder"
            class="img-fluid rounded-start" alt="...">
          <span class="col-12 " :class="class_placeholder" v-if="ativa_placeholder"></span>
          <div class="container">
            <div
              :class="['fs-5 fs-bold w-auto h-75 py-3 text-center rounded-circle text-white', (dados.nota > 50 ? 'bg-success' : (dados.nota == 50 ? 'bg-warning' : 'bg-danger'))]"
              v-if="dados.nota">
              <span class="align-middle">
                Nota <br>
                <b>
                  {{ dados.nota }}%
                </b>
              </span>
            </div>
          </div>
        </div>
        <div class="col-8">
          <div class="card-body">
            <div class="row" style="min-height: 170px;">
              <span :class="[class_placeholder, 'my-1']">
                <h5 class="card-title">{{ resumo_titulo }}</h5>
              </span>
              <span :class="[class_placeholder, 'my-1']">
                <p class="card-text" :class="class_placeholder">{{ resumo_descricao }}</p>
              </span>

              <p class="card-text col align-self-end" v-if="(dados.tag != '')" :class="class_placeholder">
                <small class="text-body-secondary">
                  tag: <a class="btn btn-sm btn-info py-0 text-white">{{ dados.tag }}</a>
                </small>
              </p>

              <span :class="[class_placeholder, 'my-1 pb-2', 'align-self-end']">
                <p class="card-text" :class="class_placeholder">
                  <button class="btn btn-sm btn-dark w-100" @click="abre_modal(dados)" v-if="!ativa_placeholder">{{
                    txt_btn }}</button>
                </p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { limita_caracteres } from '@/assets/js/functions';
import { DadosStore } from '@/stores/DadosPinia';

export default {
  name: 'CardCursos',
  props: {
    dados: {
      default: {
        imagem: '',
        titulo: '',
        descricao: '',
        tag: '',
        nota: null,
      }
    },
    txt_btn: {
      default: 'Abrir curso'
    },
    caminho_imagem: {
      default: ''
    },
    ativa_placeholder: {
      default: false
    }
  },
  computed: {
    class_placeholder: function () {
      return (this.ativa_placeholder ? 'placeholder' : '')
    },
    imagem_montada: function () {
      return ((this.dados.imagem != '' && this.dados.imagem != undefined) ? this.caminho_imagem + this.dados.imagem : '/img/logo.png')
    },
    resumo_titulo: function () {
      return this.resumo_texto(this.dados.titulo)
    },
    resumo_descricao: function () {
      return this.resumo_texto(this.dados.descricao, 50)
    },
  },
  methods: {
    resumo_texto(texto, max_caracter = 20) {
      var tam = texto.length;
      if (tam > max_caracter) {
        return limita_caracteres(texto, max_caracter) + '...';
      } else {
        return texto
      }
    },
    abre_modal(dados) {
      this.DadosAula.setCursoAberto(dados)
      this.$emit('abre_modal')
    }
  },
  data() {
    return {
      DadosAula: DadosStore(),
    }
  },
}
</script>

<style scoped></style>